<template>
  <CustomTable ref="table" class="compact-table" :filters=undefined :data="data" :loadData="loadData">
    <template v-slot:header-options>
      <button @click="$refs.addProfessionalModal.openModal()" class="button-icon"><span class="fas fa-plus"></span></button>
    </template>
    <template v-slot:table>
      <thead v-if="$refs.table">
        <tr>
          <custom-header field="name" class="col-fill">Nom</custom-header>
        </tr>
      </thead>
      <tbody v-if="data && data.length > 0">
        <tr v-for="(professional, index) in $refs.table.$refs.searchArray.simpleFilter(data)" :key="index" class="compact-row" :class="professional.status">
          <custom-body field="name" class="col-fill">{{ professional.name }}</custom-body>
        </tr>
      </tbody>
      <tbody v-else><tr style="background-color: #40513b14;font-weight: bold"><td colspan="1" style="text-align: center">Aucun professionnel enregistré</td></tr></tbody>
    </template>
  </CustomTable>
  <AddProfessionalModal ref="addProfessionalModal" :callback=loadData />
</template>

<script>
    import CustomTable from "@/components/CustomTable.vue";
    import CustomHeader from "@/components/tables/CustomHeader.vue";
    import CustomBody from "@/components/tables/CustomBody.vue";
    import {GroupController} from "@/controllers/user/GroupController";
    import AddProfessionalModal from "@/accounting/components/modals/AddProfessionalModal.vue";
    import router from "@/router";

    export default {
      name: 'ProfessionalTable',
      components: {
        AddProfessionalModal,
        CustomBody,
        CustomHeader,
        CustomTable
      },
      data: function () {
        return {
          data: [],
          elements: [
            {label: "Nom", value: "name", type: "text"},
          ],
        }
      },
      mounted(){
        this.$refs.table.$refs.searchArray.initWithURLParams();
        this.loadData();
      },
      methods: {
        router() {
          return router
        },
        async loadData(){
          this.$refs.table?.startLoading();
          this.data = [];
          const resp = await GroupController.getForAccountant(this.$refs.table.buildURLParams());
          if(!resp.errors){
            for(let i=0; i < resp.length ;i++){
              this.data.push(resp[i]);
            }
          }
          this.$refs.table?.stopLoading();
        }
      }
    }
</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';
  @require '~/src/common/style/businessTable.styl';

  .button-icon
    margin-right 10px
</style>
